import React, { useState, useEffect, memo, useRef } from 'react';

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';

import { Box, Flex, Modal, ModalOverlay, ModalBody, ModalContent, useToast } from '@chakra-ui/react';
import LaunchdeckCloseButton from '../../../global/components/helper-components/components/LaunchdeckCloseButton.jsx';

import { CreateRoomWithAiForm } from './CreateRoomWithAiForm.jsx';
import { changeDsrModalState, changeDsrPopupState, uploadFileMultithreaded, uploadFiles, uploadFilesReset } from '../../../digital-sales-room/actions/dsr-actions';
import { createGenAiRoom, resetCreateGenAiRoom, setNotifyGenAiRoomReady } from '../../../digital-sales-room/actions/dsr-gen-ai-actions.js';
import { redirectToNewPage, triggerLaunchdeckToast } from '../../../global/helpers/global-helpers.js';


function CreateRoomWithAiModal({
  handleCloseModal,
  // Actions
  changeDsrPopupState,
  changeDsrModalState,
  setNotifyGenAiRoomReady,
  uploadFiles,
  uploadFileMultithreaded,
  uploadFilesReset,
  createGenAiRoom,
  resetCreateGenAiRoom,
  // Redux states
  isMobileView,
  uploadFilesState,
  createGenAiRoomOutcome
}) {

  // UX
  const toast = useToast();
  const redirectRef = useRef(false)
  const [showLoader, setShowLoader] = useState(false);


  useEffect(() => {
    if (createGenAiRoomOutcome) {
      const { createdRoomRoute, genAiError } = createGenAiRoomOutcome || {};

      if (!!genAiError) {
        toast(
          triggerLaunchdeckToast({
            useCase: "show-error-state",
            label: "Something went wrong with generating your Room. We are aware of this problem. Please try again later",
            isMobileView
          })
        )
      }

      if (createdRoomRoute && !!redirectRef.current ) {
        redirectToNewPage(createdRoomRoute) 
      }

      resetCreateGenAiRoom()
      handleCloseModal()
    }
  }, [createGenAiRoomOutcome])

  const handleWaitTillRedirect = () => {
    redirectRef.current = true
  }


  const handleClickModalCloseButton = () => {
    handleCloseModal()
  }

  const handleIsUploadingState = () => {
    setShowLoader(true)
  }

  const renderContent = () => {
    return (
      <>
        <Flex justify='space-between' align='center' w='100%' py='0.5em'>
          <Flex px='1.5em' justify='flex-start' align='center'>
            <Box fontWeight='500' fontSize='1.1em' lineHeight='1.375em' color='brandDark.500'>{'Start a Room with AI'}</Box>
          </Flex>
          <Box pr='1.5em' display='flex' alignItems='center'>
            <LaunchdeckCloseButton handleCloseModal={() => handleClickModalCloseButton()} />
          </Box>
        </Flex>

        <Flex justify='center' w='95%'>
          <CreateRoomWithAiForm
            uploadFilesState={uploadFilesState}
            handleIsUploadingState={handleIsUploadingState}
            handleClickModalCloseButton={handleClickModalCloseButton}
            handleWaitTillRedirect={handleWaitTillRedirect}
            setNotifyGenAiRoomReady={setNotifyGenAiRoomReady}
            isMobileView={isMobileView}
            showLoader={showLoader}
            changeDsrPopupState={changeDsrPopupState}
            changeDsrModalState={changeDsrModalState}
            uploadFiles={uploadFiles}
            uploadFileMultithreaded={uploadFileMultithreaded}
            uploadFilesReset={uploadFilesReset}
            createGenAiRoom={createGenAiRoom}
          />
        </Flex>
      </>
    )
  }


  return (
    <Modal isOpen={true} closeOnOverlayClick={false} isCentered={true} preserveScrollBarGap={true} >
      <ModalOverlay />
      <ModalContent rounded='0.25em' minW={['90%', '500px']} maxW='36em'>
        <ModalBody px='0em'>
          <Flex direction='column' justify='space-around' alignItems='center' w='100%'>
            {renderContent()}
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}


const mapStateToProps = (state) => ({
  isMobileView: state.mobileViewMode.isMobileView,
  uploadFilesState: state.uploadFilesOutcome,
  createGenAiRoomOutcome: state.createGenAiRoomOutcome.results.data,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeDsrPopupState,
      changeDsrModalState,
      setNotifyGenAiRoomReady,
      uploadFiles,
      uploadFileMultithreaded,
      uploadFilesReset,
      createGenAiRoom,
      resetCreateGenAiRoom
    },
    dispatch,
  )


export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateRoomWithAiModal)))
